import React, { createContext, useContext, useState } from "react";
import AlertToast from "../common/components/Alert"; // Ensure path is correct

interface ToastContextProps {
  showToast: (message: string, type?: "success" | "error" | "warning" | "info") => void;
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toast, setToast] = useState<{ open: boolean; message: string; type?: string }>({
    open: false,
    message: "",
    type: "info",
  });

  const showToast = (message: string, type: "success" | "error" | "warning" | "info" = "info") => {
    setToast({ open: true, message, type });
    setTimeout(() => setToast({ open: false, message: "", type }), 5000); // Auto-close
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <AlertToast
        open={toast.open}
        message={toast.message}
        onClose={() => setToast({ open: false, message: "", type: "info" })}
        type={toast.type as any}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
